<script lang="ts">
  import { Component, Prop, Vue } from 'vue-property-decorator';
  import { Globals } from '@/modules/Globals';
  import { vueData } from '@/VueData';
  import SimpleScrollableModal from '../base/SimpleScrollableModal.vue';
  import { IStickerSettings } from '@/interfaces/IStickerSettings';
  import {
    LabelPrinter,
    defaultStickerSettings,
  } from '@/lib/print/LabelPrinter';
  import { AlertType } from '@/interfaces/IAlert';

  @Component({
    components: { SimpleScrollableModal },
  })
  export default class StickerSettingsModal extends Vue {
    saving = false;
    formValid = true;
    stickerSettings: IStickerSettings | null = null;

    save() {
      try {
        this.stickerSettings.width = Number(this.stickerSettings.width);
        this.stickerSettings.height = Number(this.stickerSettings.height);
        this.stickerSettings.padding.top = Number(
          this.stickerSettings.padding.top
        );
        this.stickerSettings.padding.right = Number(
          this.stickerSettings.padding.right
        );
        this.stickerSettings.padding.bottom = Number(
          this.stickerSettings.padding.bottom
        );
        this.stickerSettings.padding.left = Number(
          this.stickerSettings.padding.left
        );

        localStorage.setItem(
          'stickerSettings',
          JSON.stringify(this.stickerSettings)
        );
        this.$emit('close');
        vueData.addAlert('Configuración guardada.', AlertType.Success);
      } catch (e) {
        console.error(e);
        vueData.addAlert(
          'No se pudo guardar la configuración. Por favor, verifique que su navegador tenga habilitado el almacenamiento local.',
          AlertType.Error
        );
      }
    }

    async loadSettings() {
      this.stickerSettings = LabelPrinter.loadSettings();
    }

    mounted() {
      this.loadSettings();
    }
  }
</script>

<template>
  <simple-scrollable-modal>
    <template #title>
      <h3>Configuración de etiqueta</h3>
    </template>
    <template #content>
      <template v-if="stickerSettings">
        <v-form v-model="formValid" @submit.prevent>
          <div class="setting-row">
            <!-- Print Density -->
            <v-select
              label="Densidad"
              :items="['6dpmm', '8dpmm', '12dpmm', '24dpmm']"
              outlined
              v-model="stickerSettings.printDensity"
              required
              dense
            ></v-select>

            <!-- Dimensions -->
            <v-text-field
              label="Ancho (mm)"
              type="number"
              outlined
              dense
              v-model="stickerSettings.width"
              required
              suffix="mm"
            ></v-text-field>
            <v-text-field
              label="Alto (mm)"
              type="number"
              outlined
              dense
              v-model="stickerSettings.height"
              required
              suffix="mm"
            ></v-text-field>
          </div>

          <div class="setting-row">
            <!-- Padding -->
            <v-text-field
              label="Separación Arriba (mm)"
              type="number"
              outlined
              dense
              v-model="stickerSettings.padding.top"
              required
              suffix="mm"
            ></v-text-field>
            <v-text-field
              label="Separación Derecha (mm)"
              type="number"
              outlined
              dense
              v-model="stickerSettings.padding.right"
              required
              suffix="mm"
            ></v-text-field>
            <v-text-field
              label="Separación Abajo (mm)"
              type="number"
              outlined
              dense
              v-model="stickerSettings.padding.bottom"
              required
              suffix="mm"
            ></v-text-field>
            <v-text-field
              label="Separación Izquierda (mm)"
              type="number"
              outlined
              dense
              v-model="stickerSettings.padding.left"
              required
              suffix="mm"
            ></v-text-field>
          </div>

          <div class="setting-row">
            <!-- Font Size -->
            <v-select
              label="Tamaño de letra"
              :items="['xs', 's', 'm', 'l']"
              outlined
              dense
              v-model="stickerSettings.fontSize"
              required
            ></v-select>
          </div>
        </v-form>
      </template>
    </template>
    <template #action-bar>
      <div class="d-flex flex-row justify-end">
        <v-btn
          color="danger"
          text
          depressed
          @click="$emit('close')"
          :disabled="saving"
        >
          Cerrar
        </v-btn>
        <v-btn color="info" depressed @click="save" :loading="saving">
          Guardar
        </v-btn>
      </div>
    </template>
  </simple-scrollable-modal>
</template>

<style scoped lang="scss">
  .setting-row {
    @apply tw-flex tw-items-center tw-space-x-2 #{!important};

    &:first-child {
      @apply tw-mt-2;
    }
  }
</style>
